import { FlexBox } from '@ardoq/layout';
import { Icon, IconName, IconSize } from '@ardoq/icons';
import { PropsWithChildren } from 'react';
import { Text } from '@ardoq/typography';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';
import { t, type WithI18nLocale } from '@ardoq/i18n';

export const PRIORITY_FIELD_CLASS = 'priority-field';

type PriorityWrapperProps = WithI18nLocale;

export const PriorityWrapper = ({
  children,
  i18nLocale,
}: PropsWithChildren<PriorityWrapperProps>) => {
  return (
    <OuterFlexBox
      className={PRIORITY_FIELD_CLASS}
      borderRadius="r8"
      flexDirection="column"
      width="full"
    >
      <BannerTextBox flexDirection="row" padding="small" gap="small">
        <Icon
          iconName={IconName.REQUIREMENT}
          iconSize={IconSize.SMALL}
          color={colors.textAction}
        ></Icon>
        <PriorityText variant="caption">
          {t(i18nLocale, 'surveysUi:priorityQuestion', 'Priority question')}
        </PriorityText>
      </BannerTextBox>
      <FlexBox padding="small">{children}</FlexBox>
    </OuterFlexBox>
  );
};

const PriorityText = styled(Text)`
  color: ${colors.textAction};
`;

const OuterFlexBox = styled(FlexBox)`
  border: 1px solid ${colors.borderInfo};
  overflow: hidden;
`;

const BannerTextBox = styled(FlexBox)`
  border-bottom: 1px solid ${colors.borderInfo};
  background: ${colors.surfaceInfo};
`;
